import { render } from "./tarifahabitacion.vue?vue&type=template&id=51af278c&scoped=true"
import script from "./tarifahabitacion.vue?vue&type=script&lang=js"
export * from "./tarifahabitacion.vue?vue&type=script&lang=js"

import "./tarifahabitacion.vue?vue&type=style&index=0&id=51af278c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51af278c"]])

export default __exports__